// Libraries
import React from 'react';
import ReactDOM from 'react-dom';

import { Index as BusinessIndex } from './__business/index';
import { Index as PersonalIndex } from './__personal/index';

const loc = window.location.pathname
const subdir = loc.split('/')[1]
let Core

if (subdir === 'psl') {
	Core = PersonalIndex
} else if(subdir === 'biz'){
	Core = BusinessIndex
}

ReactDOM.render(
<Core/>, document.getElementById('root'));